/**
 * The loosest useful check for an address typed into "Get Started": something, an `@`, a domain
 * with a dot, no whitespace. Deliberately NOT a full RFC 5322 validator — the address is only
 * recorded locally at this point and is verified for real when the user later signs up with it
 * and enters the emailed code, so the check exists to catch an obviously mistyped field, not to
 * reject unusual but valid addresses.
 */
const PLAUSIBLE_EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/u;

export function isPlausibleEmail(value: string): boolean {
  return PLAUSIBLE_EMAIL_RE.test(value.trim());
}
